module.exports = __webpack_public_path__ + "media/images/front/brands/creations/creations_header_m-95f72f6054f09004547fa57d39ceeece.webp";